export enum InvoiceOrExpenseEnum {
  invoice = 'recebimentos',
  expense = 'despesas',
}
